<template>
  <div>
    <div class="topP">
      <div class="top">
        <div
          class="topSubP"
          ref="topSubP"
        >
          <div class="topSub">
            <div class="topLLP">
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20260127151631.png"
              />
              <div>微脉水印相机 素材团队管理后台</div>
            </div>
            <div class="topRP">
              <div class="topRP">
                <div class="topRR2">
                  <img
                    v-if="faceIcon && faceIcon.length"
                    class="header-main-top"
                    :src="faceIcon"
                  />
                  <img
                    v-else
                    class="header-main-top"
                    src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png"
                  />
                  <div>{{ userName }}</div>
                </div>
                <div
                  class="logoutBtn"
                  @click="logout"
                >
                  退出登录
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentP">
      <div class="topBP">
        <div class="topB">
          <div class="topLP">当前团队：</div>
          <div class="topRP">
            <div
              v-if="teamList && teamList.length && teamSelIdx >= 0"
              class="topL"
            >
              <div class="topLR">
                {{ teamList[teamSelIdx].teamName }}
              </div>
              <img
                v-if="teamList[teamSelIdx].roleType == 100"
                class="topLL"
                src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png"
              />
              <img
                v-else-if="teamList[teamSelIdx].roleType == 90"
                class="topLL"
                src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"
              />
            </div>
            <div class="topR">
              <div
                class="changeTeamBtn"
                @click="changeTeam"
              >
                切换团队
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="contentL">
          <div
            :class="
              tabIndex == 0 ? 'contentLItem contentLItemLight' : 'contentLItem'
            "
            @click="tabClick(0)"
          >
            素材列表
          </div>
          <div
            :class="
              tabIndex == 1 ? 'contentLItem contentLItemLight' : 'contentLItem'
            "
            @click="tabClick(1)"
          >
            定时列表
          </div>
        </div>
        <div class="contentR">
          <div
            v-if="tabIndex == 0"
            class="filterBar"
          >
            <div
              v-if="tabIndex == 1"
              class="timeSendLabel"
            >
              定时素材
            </div>
            <el-input
              class="filterInput"
              v-model="keywords"
              placeholder="输入关键词"
            ></el-input>
            <el-select
              class="filterInput"
              v-model="categoryId"
              placeholder="全部分类"
            >
              <el-option
                v-for="op in categoryList"
                :key="op.labelid"
                :label="op.labelName"
                :value="op.labelid"
              >
              </el-option>
            </el-select>
            <el-select
              class="filterInput"
              v-model="tagId"
              placeholder="选择标签"
            >
              <el-option
                v-for="op in tagList"
                :key="op.tagid"
                :label="op.tagName"
                :value="op.tagid"
              >
              </el-option>
            </el-select>
            <div
              class="filterBtn"
              @click="searchSucai"
            >
              查找素材
            </div>
            <div
              v-if="tabIndex == 0"
              class="releaseBtn"
              @click="releaseSucaiClick"
            >
              发布素材
            </div>
          </div>
          <div>
            <div class="listTitleBar">
              <div
                class="listTitleBarItem"
                :style="{ width: '270px' }"
              >
                文案
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '448px' }"
              >
                图片视频
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '180px', textAlign: 'center' }"
              >
                分类
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '140px', textAlign: 'center' }"
              >
                发布时间
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '140px', textAlign: 'center' }"
              >
                发布人
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '178px', textAlign: 'center' }"
              >
                操作
              </div>
            </div>
            <div class="list">
              <div
                v-for="(item, idx) in sucaiList"
                :key="idx"
                class="listContentBar"
                :style="{
                  'background-color': hoverIdx == idx ? '#FAFAFA' : '#fff',
                }"
                @mouseenter="hoverIdx = idx"
                @mouseleave="hoverIdx = -1"
              >
                <div
                  v-if="item.isTop == 1"
                  class="topSucaiIcon"
                >
                  置顶
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '238px',
                    padding: '0 16px',
                    display: '-webkit-box',
                    height: 'calc(100% - 32px)',
                  }"
                  @mouseenter.stop="listItemMouseEnter(idx)"
                >
                  <div
                    class="shadowTipSize"
                    :ref="'shadowTipSize' + idx"
                  >
                    {{ item.detail }}
                  </div>
                  <el-tooltip
                    v-if="item.needTooltip"
                    placement="top"
                  >
                    <div slot="content">
                      <div class="tooltipContent">{{ item.detail }}</div>
                    </div>
                    <div>{{ item.detail }}</div>
                  </el-tooltip>
                  <div v-else>{{ item.detail }}</div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  v-if="item.mediaType == 1"
                  class="listContentBarItem"
                  :style="{
                    width: '432px',
                    padding: '0 8px',
                    justifyContent: 'flex-start',
                  }"
                >
                  <div
                    v-for="(img, idx) in item.imageUrls.slice(0, 5)"
                    :key="idx"
                    class="imgContentItem"
                  >
                    <img
                      class="imgContentItemImg"
                      :src="item.domain + img.picUrl"
                      @click.stop="go2Preview(item, idx)"
                    />
                    <div
                      v-if="idx == 4"
                      class="imgMore"
                      @click.stop="go2ImgMore(item)"
                    >
                      <div>
                        <div>共{{ item.imageUrls&&item.imageUrls.length<=9&&item.imageUrls[0].hiddenCount?item.imageUrls.length+ item.imageUrls[0].hiddenCount:item.imageUrls.length }}张</div>
                        <div>查看全部</div>
                      </div>
                    </div>
                  </div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  v-else-if="item.mediaType == 2"
                  class="listContentBarItem"
                  :style="{
                    width: '416px',
                    padding: '0 8px',
                    justifyContent: 'flex-start',
                  }"
                >
                  <div
                    class="videoContentItem"
                    @click.stop="previewVideo(item)"
                  >
                    <img
                      class="videoContentItemPlayIcon"
                      src="https://imagessl.lingtuo.cn/A-1ed71af7_20260127180929.png"
                    />
                    <img
                      class="videoContentItemImg"
                      :src="
                        $common.getVideoPoster(item.mediaDomain + item.videoKey)
                      "
                    />
                  </div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  v-else-if="item.mediaType == 3"
                  class="listContentBarItem"
                  :style="{
                    width: '416px',
                    padding: '0 8px',
                    justifyContent: 'flex-start',
                  }"
                >
                  <div class="linkContentItem">
                    <img
                      v-if="item.imageUrls.length > 0"
                      class="linkContentItemIcon"
                      :src="item.domain + item.imageUrls[0].picUrl"
                    />
                    <div>
                      <div class="linkContentItemR1">
                        {{ item.articleTitle }}
                      </div>
                      <a
                        class="linkContentItemR2"
                        :href="
                          item.articleUrl.startsWith('http')
                            ? item.articleUrl
                            : 'https://' + item.articleUrl
                        "
                        target="_blank"
                        >{{ item.articleUrl }}</a
                      >
                    </div>
                  </div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '164px',
                    padding: '0 8px',
                    flexWrap: 'wrap',
                  }"
                >
                  {{
                    item.labelData
                      ? item.labelData.map((item) => item.labelName).join("、")
                      : ""
                  }}
                  <span
                    v-if="
                      item.labelData &&
                      item.labelData.length > 0 &&
                      item.tagData &&
                      item.tagData.length > 0
                    "
                    >-</span
                  >
                  <span v-if="item.tagData && item.tagData.length > 0">
                    {{
                      item.tagData
                        ? item.tagData.map((item) => item.tagName).join(",")
                        : ""
                    }}
                  </span>
                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '124px',
                    padding: '0 8px',
                    display: 'grid',
                  }"
                >
                  <div>
                    {{ item.createTime ? item.createTime.split(" ")[0] : "" }}
                  </div>
                  <div>
                    {{ item.createTime ? item.createTime.split(" ")[1] : "" }}
                  </div>
                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '124px',
                    padding: '0 8px',
                    display: 'grid',
                  }"
                >
                  <img
                    class="listContentUserIcon"
                    :src="item.faceIcon"
                  />
                  {{ item.nickname }}
                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '162px',
                    padding: '0 8px',
                    flexWrap: 'wrap',
                  }"
                  v-if="teamList[teamSelIdx].roleType != 0"
                >
                  <div
                    class="listContentBarActionItem"
                    @click="editClick(item)"
                  >
                    编辑
                  </div>
                  <div
                    v-if="tabIndex == 0"
                    class="listContentBarActionItem"
                    @click="copyClick(item)"
                  >
                    复用
                  </div>
                  <!-- <div
                  v-if="tabIndex == 0"
                  class="listContentBarActionItem"
                  @click="refreshClick(item)"
                >
                  刷新
                </div> -->
                  <div
                    class="listContentBarActionItem listContentBarActionItemDelete"
                    @click="tabIndex == 0 ? deleteClick(item) : delTask(item)"
                  >
                    删除
                  </div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '152px',
                    padding: '0 8px',
                    flexWrap: 'wrap',
                  }"
                  v-else
                ></div>
                <div
                  v-if="item.isVisible != 1"
                  class="cellCover"
                  @click.stop
                >
                  <div class="background-container">
                    <div class="glass-mask">
                      <div class="glass-mask-main">
                        <img
                          src="https://imagessl.lingtuo.cn/A-1ed71af7_20260303170105.png"
                        />
                        无查看权限
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pageBar">
              <div
                class="pageBtn"
                @click="handlePageChange(false)"
              >
                上一页
              </div>
              <div>
                <input
                  class="pageInput"
                  type="number"
                  v-model="page"
                  @keyup.enter="handlePageEnter"
                />
              </div>
              <div
                class="pageBtn"
                @click="handlePageChange(true)"
              >
                下一页
              </div>
              <!-- <el-pagination
              style="display: flex; align-items: center"
              background
              :page-size="pageSize"
              :current-page.sync="page"
              layout=" prev, slot, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
              <div>
                <input
                  class="pageInput"
                  type="number"
                  v-model="page"
                />
              </div>
            </el-pagination> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="teamListShow"
      class="teamListCover"
    >
      <!-- <div
        class="listAdd listAdd2"
        @click="createTeam"
      >
        <img
          src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812095807.png"
        />新建团队
      </div> -->
      <div class="listAdd listAdd2"></div>
      <div class="teamListP">
        <div class="teamList">
          <div
            v-for="(item, idx) in teamList"
            :key="'teamListItem' + idx"
            :class="
              idx == teamSelIdx
                ? 'teamListItemSel teamListItem'
                : 'teamListItem'
            "
            @click="teamItemClick(idx)"
          >
            <img
              v-if="item.roleType == 90"
              src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"
            />
            <img
              v-else-if="item.roleType == 100"
              src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"
            />
            <div>{{ item.teamName }}</div>
          </div>
        </div>
      </div>
      <img
        src="https://imagessl.lingtuo.cn/A-1ed71af7_20250919100121.png"
        class="themeListCloseBtn"
        @click="hideTeamList"
      />
    </div>
    <transition name="fade">
      <EditSucai
        v-if="editSucaiShow"
        ref="editSucai"
        @close="editClose"
      />
    </transition>
    <transition name="fade">
      <ReuseSucai
        v-if="reuseSucaiShow"
        ref="reuseSucai"
        @close="reuseSucaiShow = false"
      />
    </transition>
    <!-- 新增：视频预览遮罩层 -->
    <div
      v-if="videoPreviewShow"
      class="videoPreviewMask"
      @click="closeVideoPreview"
    >
      <div
        class="videoPreviewContent"
        @click.stop
      >
        <video
          :src="currentVideoUrl"
          controls
          autoplay
          class="videoPlayer"
        ></video>
        <div
          class="videoCloseBtn"
          @click="closeVideoPreview"
        >
          ×
        </div>
      </div>
    </div>
    <div
      class="oldBtn"
      @click="go2old"
    >
      回旧版
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EditSucai from "@/components/EditSucai.vue";
import ReuseSucai from "@/components/ReuseSucai.vue";
import Vue from "vue";
import {
  Dialog,
  Button,
  Loading,
  Radio,
  RadioGroup,
  Switch,
  Popover,
  Select,
  Option,
  Input,
  Tooltip,
} from "element-ui";
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Tooltip);

export default {
  name: "Home",
  data() {
    return {
      pageWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      pageHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      tabIndex: 0,
      teamSelIdx: -1,
      teamListLoadend: false,
      teamList: [],
      teamListShow: false,
      loading: false,
      hoverIdx: -1,
      categoryList: [],
      keywords: "",
      editSucaiShow: false,
      reuseSucaiShow: false,
      page: 1,
      pageSize: 10,
      tagList: [],
      categoryId: "",
      tagId: "",
      sucaiList: [],
      videoPreviewShow: false,
      currentVideoUrl: "",
    };
  },
  computed: {},
  watch: {
    teamSelIdx: {
      async handler(newVal, oldVal) {
        if (newVal != oldVal && newVal >= 0) {
          this.keywords = "";
          this.page = 1;
          this.sucaiList = [];
          this.categoryId = "";
          this.tagId = "";
          if (this.tabIndex == 0) {
            await this.queryCategoryList();
            await this.queryTagList();
          }
          await this.querySucaiList();
        }
      },
      immediate: true,
    },
    tabIndex: {
      async handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.keywords = "";
          this.page = 1;
          this.sucaiList = [];
          this.categoryId = "";
          this.tagId = "";
          if (this.teamSelIdx == -1) {
            this.queryTeamList();
          } else {
            await this.querySucaiList();
          }
        }
      },
      immediate: true,
    },
    categoryId: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal != "") {
            this.tagId = "";
          }
          if (this.teamSelIdx != -1) {
            this.page = 1;
            this.sucaiList = [];
            this.queryTagList(newVal);
            this.querySucaiList();
          }
        }
      },
      immediate: true,
    },
    tagId: {
      handler(newVal, oldVal) {
        if (newVal != "") {
          this.categoryId = "";
        }
        if (newVal != oldVal) {
          if (this.teamSelIdx != -1) {
            this.page = 1;
            this.sucaiList = [];
            this.querySucaiList();
          }
        }
      },
      immediate: true,
    },
  },
  components: { EditSucai, ReuseSucai },
  methods: {
    tabClick(index) {
      this.tabIndex = index;
      localStorage.setItem("tabIndex", index);
    },
    go2old() {
      window.location.href = "https://service.lingtuo.cn/web/index.html";
    },
    listItemMouseEnter(idx) {
      let item = this.sucaiList[idx];
      const dom = this.$refs["shadowTipSize" + idx][0];
      // 核心判断：内容总高度 > 可视高度
      if (dom.scrollHeight > dom.clientHeight) {
        item.needTooltip = true;
        this.sucaiList.splice(idx, 1, item);
      }
    },
    // 新增：视频预览方法
    previewVideo(item) {
      this.currentVideoUrl = item.mediaDomain + item.videoKey;
      this.videoPreviewShow = true;
    },
    // 新增：关闭视频预览
    closeVideoPreview() {
      this.videoPreviewShow = false;
      this.currentVideoUrl = "";
    },
    handlePageEnter() {
      this.querySucaiList();
    },
    handlePageChange(isNext) {
      if (isNext && this.sucaiList.length == this.pageSize) {
        ++this.page;
        this.querySucaiList();
      } else if (this.page > 1 && !isNext) {
        --this.page;
        this.querySucaiList();
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.querySucaiList();
    },
    editClose(needRefresh) {
      this.editSucaiShow = false;
      if (needRefresh) {
        this.querySucaiList();
      }
    },
    searchSucai() {
      this.page = 1;
      this.querySucaiList();
    },
    teamItemClick(idx) {
      this.teamSelIdx = idx;
      this.teamListShow = false;
      localStorage.setItem("currentTeamIndex", idx);
    },
    async go2Preview(sucaiItem, idx) {
      let _this = this;
      console.log("go2Preview:", sucaiItem);
      let imgList = sucaiItem.imageUrls;
      
      if(imgList.length&&imgList.length<=9&&imgList[0].hiddenCount){
        let moreList = await this.getSucaiImgMore(sucaiItem);
        if(moreList.length){
          imgList=moreList;
          sucaiItem.imageUrls = imgList;
        }
      }

      this.$viewerApi({
        images: imgList.map((item) => sucaiItem.domain + item.picUrl),
        options: {
          // 这里可以配置 viewer.js 的原生选项
          toolbar: true,
          navbar: true,
          images: this.sourceImageObjects,
          initialViewIndex: idx,
        },
      });
    },
    async getSucaiImgMore(sucaiItem){
      return new Promise(async (resolve,reject)=>{
        let resp = await this.$http.querySucaiImageListMore({
          teamNO: this.teamList[this.teamSelIdx].teamNO,
          mid: sucaiItem.id
        })
        console.log("querySucaiImageListMore resp:",resp);
        if(resp.code==200){
          resolve(resp.data.array)
        }
      })
    },
    //查看全部图片
    async go2ImgMore(sucaiItem) {
      let imgList = sucaiItem.imageUrls;
      if(imgList.length&&imgList.length<=9&&imgList[0].hiddenCount){
        let moreList = await this.getSucaiImgMore(sucaiItem);
        if(moreList.length){
          imgList=moreList;
          sucaiItem.imageUrls = imgList;
        }
      }
      this.$viewerApi({
        images: imgList.map((item) => sucaiItem.domain + item.picUrl),
        options: {
          // 这里可以配置 viewer.js 的原生选项
          toolbar: true,
          navbar: true,
          images: this.sourceImageObjects,
        },
      });
    },
    logout() {
      localStorage.clear();
      setTimeout(() => {
        window.location.reload();
      }, 10);
      this.$router.replace({ path: "/wlogin" });
    },
    releaseSucaiClick() {
      let team = this.teamList[this.teamSelIdx];
      if (!team.roleType) {
        this.$message({
          type: "warning",
          message: "无发布权限",
        });
        return;
      }

      this.editSucaiShow = true;
      setTimeout(() => {
        this.$refs.editSucai.setSucai({
          team: team,
          sucai: null,
          tagList: this.tagList,
          categoryList: this.categoryList,
        });
      }, 0);
    },
    //编辑
    editClick(item) {
      console.log("editClick:", item);
      this.editSucaiShow = true;
      setTimeout(() => {
        this.$refs.editSucai.setSucai({
          team: this.teamList[this.teamSelIdx],
          sucai: item,
          isTask: this.tabIndex == 1,
        });
      }, 0);
    },
    //复用
    copyClick(item) {
      console.log("copyClick:", item);
      this.reuseSucaiShow = true;
      setTimeout(() => {
        this.$refs.reuseSucai.setSucai({
          teamList: this.teamList,
          sucai: item,
        });
      }, 0);
    },
    //刷新
    refreshClick(item) {
      console.log("refreshClick:", item);
    },
    //删除定时任务
    delTask(item) {
      console.log("delTask:", item);
      this.$confirm("确定删除这条定时任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let resp = await this.$http.delTask({
            id: item.id,
            teamNo: item.teamNO,
          });

          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.querySucaiList();
          }
        })
        .catch(() => {});
    },
    //删除
    deleteClick(item) {
      console.log("deleteClick:", item);
      this.$confirm("确定删除这条素材?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let resp = await this.$http.delSucai({
            id: item.id,
            teamNo: item.teamNO,
          });

          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.querySucaiList();
          }
        })
        .catch(() => {});
    },
    createTeam() {
      this.$confirm(
        '<div><input id="confirmInput" placeholder="请输入团队名称" /><div id="confirmSwitch">成员加入审核<img id="confirmSwitchOpen" src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826142740.png" /><img id="confirmSwitchClose" src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826150435.png" /></div></div>',
        "创建团队",
        {
          confirmButtonText: "保存",
          cancelButtonText: "取消",
          inputPattern: /^.+$/,
          inputErrorMessage: "团队名称不能为空",
          dangerouslyUseHTMLString: true,
        },
      ).then(async (res) => {
        if (res) {
          let teamName = document.getElementById("confirmInput").value;
          console.log("teamName:", teamName);

          let params = {
            name: teamName,
            isCheck: this.joinNeedCheck ? 1 : 0,
          };
          let resp = await this.$http.huashuTeamCreate(params);
          if (resp.code == 200) {
            document.getElementById("confirmInput").value = "";
            this.$message({
              message: "创建成功",
              type: "success",
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      });
      // setTimeout(() => {
      //   document
      //     .getElementById("confirmSwitch")
      //     .addEventListener("click", this.confirmSwitchClick);
      // }, 1);
    },
    changeTeam() {
      this.teamListShow = true;
    },
    hideTeamList() {
      this.teamListShow = false;
    },
    //查询分类列表
    queryCategoryList() {
      return new Promise(async (resolve, reject) => {
        if (!this.teamList.length) {
          resolve();
          return;
        }
        let params = {
          teamNo: this.teamList[this.teamSelIdx].teamNO,
        };
        let resp = await this.$http.queryCategoryList(params);
        if (resp.code == 200) {
          let allItme = {
            labelid: "",
            labelName: "全部分类",
          };
          this.categoryList = [allItme, ...resp.data.array];
        }
        resolve();
      });
    },
    //查询团队列表
    queryTeamList() {
      return new Promise(async (resolve, reject) => {
        let params = {};
        let resp = await this.$http.queryTeamList(params);
        if (resp.code == 200) {
          this.teamList = resp.data.array;
          if (localStorage.getItem("currentTeamIndex")) {
            this.teamSelIdx = localStorage.getItem("currentTeamIndex");
          } else {
            this.teamSelIdx = 0;
          }
        }
        resolve();
      });
    },
    //查询标签列表
    queryTagList(categoryId) {
      return new Promise(async (resolve, reject) => {
        if (!this.teamList.length) {
          resolve();
          return;
        }
        let params = {
          teamNo: this.teamList[this.teamSelIdx].teamNO,
        };
        if (categoryId) {
          params.labelId = categoryId;
        }
        let resp = await this.$http.queryTagList(params);
        if (resp.code == 200) {
          let allItem = {
            tagid: "",
            tagName: "全部标签",
          };
          this.tagList = [allItem, ...resp.data.array];
        }
        resolve();
      });
    },
    //查询话术文件标题
    async querySucaiList() {
      return new Promise(async (resolve, reject) => {
        if (!this.teamList.length) {
          resolve([]);
          return;
        }
        let params = {
          page: Number(this.page),
          pageSize: this.pageSize,
          teamNo: this.teamList[this.teamSelIdx].teamNO,
        };

        let resp;
        if (this.tabIndex == 0) {
          params.keyword = this.keywords;
          if (this.categoryId) {
            params.labelId = this.categoryId;
          } else {
            params.labelId = 0;
          }
          if (this.tagId) {
            params.tagId = this.tagId;
          }
          resp = await this.$http.querySucaiList(params);
        } else {
          resp = await this.$http.queryTaskList(params);
        }

        if (resp.code == 200) {
          let data = resp.data;
          if (this.tabIndex == 0) {
            data = JSON.parse(
              this.$common.decrypt(
                resp.data,
                localStorage.getItem("edujia:group:web:key"),
              ),
            );
          }

          console.log("querySucaiList res:", data);
          this.sucaiList = data.array.map((item) => {
            if (item.imageUrls.length && typeof item.imageUrls == "string") {
              item.imageUrls = JSON.parse(item.imageUrls);
            }
            if (typeof item.labelData == "string" && item.labelData.length) {
              item.labelData = JSON.parse(item.labelData);
            }

            if (typeof item.tagData == "string" && item.tagData.length) {
              item.tagData = JSON.parse(item.tagData);
            }
            return item;
          });
          resolve();
        } else {
          resolve([]);
        }
      });
    },
  },
  async created() {
    window.addEventListener("resize", () => {
      this.pageWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.pageHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    });
    this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon");
    this.userName = localStorage.getItem("edujia:group:web:userName");
    if (localStorage.getItem("tabIndex")) {
      this.tabIndex = parseInt(localStorage.getItem("tabIndex"));
    }
    if (localStorage.getItem("edujia:group:web:token")) {
      this.$store.commit(
        "modifyToken",
        localStorage.getItem("edujia:group:web:token"),
      );
    }
  },
  mounted() {},
  activated() {},
};
</script>

<style>
html {
  background-color: #f5f6f6;
}

body {
  width: 1500px;
  margin: auto;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  height: 40px;
  width: 40px;
}

.el-dialog__body {
  padding: 10px 20px;
}

/* 隐藏垂直滚动条 */
::-webkit-scrollbar {
  width: 0;
}

/* 隐藏水平滚动条 */
::-webkit-scrollbar {
  height: 0;
}

.el-message-box {
  display: inline-block;
  width: 80%;
  min-width: 200px;
  /* max-width: 300px; */
  max-width: 580px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

#confirmInput {
  width: 500px;
  height: 24px;
  background-color: #f5f6f6;
  border: none;
  border-radius: 6px;
  padding: 23px 16px;
  font-size: 18px;
}

#confirmSwitch {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

#confirmSwitch img {
  width: 50px;
  height: 25px;
  margin-left: 20px;
}

#confirmSwitchClose {
  display: none;
}
</style>

<style scoped>
.list {
  width: 100%;
  height: calc(100vh - 387px);
  overflow: scroll;
  background-color: #fff;
}

.contentP {
  /* min-width: 1500px; */
  margin-top: 80px;
}

.content {
  display: flex;
  height: calc(100vh - 144px);
}

.contentL {
  width: 144px;
  height: 100%;
  border-right: 1px solid #eeeeee;
}

.contentR {
  width: calc(100% - 144px);
  height: 100%;
  background-color: #fff;
}

.topP {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.top {
  box-shadow: 0 2px 4px 0 #e5e5e58a;
  width: 100%;
  min-width: 200px;
  height: 64px;
  background-color: #fff;
}

.topBP {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.topB {
  width: 100%;
  padding: 0 24px;
  height: 64px;
  background-color: #fafafa;
  display: flex;
  align-items: center;
}

.topSubP {
  width: 100%;
  height: 100%;
  /* overflow-x: scroll; */
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.topSub {
  display: flex;
  justify-content: space-between;
  width: 1208px;
}

.topLP {
  font-size: 20px;
  color: #3c3c3c;
  font-weight: 500;
}

.topLLP {
  margin-left: 16px;
  display: flex;
  align-items: center;
  min-width: 120px;
}

.topLLP img {
  width: 48px;
  height: 48px;
}

.topLLP div {
  font-size: 24px;
  color: #3c3c3c;
  margin-left: 16px;
  font-weight: 600;
}

.topL {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.topLL {
  width: 20px;
  height: 20px;
  margin-left: 8px;
}

.topLR {
  font-size: 22px;
  font-weight: 600;
  color: #3c3c3c;
  margin-left: 8px;
  max-width: 150px;
  height: 32px;
  line-height: 32px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.topRP {
  display: flex;
  align-items: center;
  min-width: 170px;
}

.topRR2 {
  display: flex;
  align-items: center;
  font-size: 20px;
}

.topRR2 img {
}

.changeTeamBtn {
  width: 80px;
  height: 36px;
  background-color: #fb5d5c;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.topR {
  display: flex;
  align-items: center;
  /*    margin-right: 16px;*/
}

.teamListCover {
  position: absolute;
  top: 80px;
  left: 50%;
  margin-left: -604px;
  width: 1208px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  z-index: 1000;
  padding-bottom: 24px;
}

.teamListP {
  display: flex;
  justify-content: center;
}

.teamList {
  width: 89.74%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 10px;
}

.themeListCloseBtn {
  position: absolute;
  top: 22px;
  right: 15px;
  width: 20px;
  height: 20px;
}

.teamListItem {
  width: 18%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background-color: #f5f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #3c3c3c;
  font-size: 14px;
  flex-basis: calc(18% - 16px);
  /* 让每个子元素等分，这里假设有3个子元素，减去10px的间隔 */
  margin: 10px;
  /* 添加间隔 */
  box-sizing: border-box;
  position: relative;
}

.teamListItem img {
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
}

.teamListItem div {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  overflow: hidden;
  text-align: center;
}

.teamListItemSel {
  border-color: #fb5d5c;
  background-color: #fff6f6;
  color: #fb5d5c;
}

.listAdd2 {
  margin-left: 27px;
  margin-top: 23px;
}

.listAdd {
  display: flex;
  align-items: center;
  color: #4a90e2;
  font-size: 18px;
}

.listAdd img {
  width: 19px;
  height: 19px;
  margin-right: 8.5px;
}

.contentLItem {
  width: 100%;
  height: 57px;
  font-size: 18px;
  font-weight: 600;
  color: #3c3c3c;
  border: 1px solid #eeeeee;
  border-right: none;
  border-top: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f6f6;
}

.contentLItemLight {
  background-color: #fff;
  color: #fb5d5c;
}

.filterBar {
  margin-left: 24px;
  display: flex;
  align-items: center;
  height: 88px;
}

.filterInput {
  width: 192px !important;
  margin-right: 16px;
}

.filterBtn {
  width: 136px;
  height: 48px;
  background-color: #ffecec;
  color: #fb5d5c;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
}

.releaseBtn {
  width: 160px;
  height: 48px;
  background-color: #fb5d5c;
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  margin-left: 336px;
}

.listTitleBar {
  height: 40px;
  background-color: #f5f6f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-top: 32px; */
}

.listTitleBarItem {
  text-indent: 16px;
}

.listContentBarItem {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: unset;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  min-height: 80px;
}

.listTitleBarItemBorder {
  width: 1px;
  height: 80px;
  background-color: #e5e5e5;
  position: absolute;
  right: 0;
  top: calc(50% - 40px);
}

.listContentBar {
  height: 133px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.imgContentItem {
  width: 80px;
  height: 80px;
  margin-left: 4px;
  position: relative;
}

.imgContentItemImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoContentItem {
  width: 80px;
  height: 80px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.videoContentItemImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoContentItemPlayIcon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.linkContentItem {
  display: flex;
  align-items: center;
}

.linkContentItemIcon {
  width: 80px;
  height: 80px;
}

.linkContentItemR1 {
  margin-left: 12px;
  font-size: 14px;
}

.linkContentItemR2 {
  margin-left: 12px;
  font-size: 14px;
  color: #4a90e2;
}

.listContentUserIcon {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin: auto;
}

.listContentBarActionItem {
  width: 56px;
  height: 32px;
  border-radius: 4px;
  background-color: #e2efff;
  color: #4a90e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  margin: 4px;
}

.listContentBarActionItemDelete {
  background-color: #ffecec;
  color: #fb5d5c;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.logoutBtn {
  width: 80px;
  height: 32px;
  background-color: #ffecec;
  color: #fb5d5c;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
}

.header-main-top {
  width: 38px;
  height: 38px;
  margin-right: 8px;
}

.imgMore {
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.timeSendLabel {
  font-size: 22px;
  font-weight: 600;
  margin-right: 62px;
}

.pageBar {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 40px;
}

.pageInput {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  font-size: 14px;
  text-align: center;
  margin: 0 16px;
}

.pageBtn {
  width: 92px;
  height: 40px;
  background-color: #ffffff;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3c3c3c;
}

.topSucaiIcon {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 18px;
  background-color: #f49a24;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 新增视频预览样式 */
.videoPreviewMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3000; /* 确保层级高于其他元素 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoPreviewContent {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  background: #000;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  display: flex;
}

.videoPlayer {
  max-width: 100%;
  max-height: 80vh;
  outline: none;
}

.videoCloseBtn {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.videoCloseBtn:hover {
  background: rgba(255, 255, 255, 0.6);
}

/* 补充：让视频列表项鼠标变成手型 */
.videoContentItem {
  cursor: pointer;
}

.tooltipContent {
  width: 400px;
  word-break: break-all;
  white-space: pre-wrap;
  line-height: 30px;
  font-size: 15px;
}

.shadowTipSize {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: unset;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  width: 144px;
  height: 100%;
  overflow: scroll;
  position: absolute;
  top: 0px;
  right: 500px;
}

.oldBtn {
  position: absolute;
  right: 10px;
  top: 15px;
  font-size: 30px;
  width: 80px;
  height: 32px;
  background-color: #ffecec;
  color: #fb5d5c;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
}

.cellCover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
}

/* .cellCover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.cellCover ::before {
  width: 100%;
  height: 100%;
  background-color: #f5f6f6;
  filter: blur(5px);
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
 */

/* 模拟页面背景 */
.background-container {
  width: 100%;
  height: 100%;
  /* background: url("https://picsum.photos/1200/800") no-repeat center
    center/cover; */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 核心代码 */
.glass-mask {
  width: 100%;
  height: 100%;
  color: #3c3c3c;

  /* 1. 设置背景颜色为半透明 (必须，否则看不到背后) */
  /* background: rgba(255, 255, 255, 0.2); */
  background-color: #fafafa;

  /* 2. 使用背景滤镜进行高斯模糊 */
  /* -webkit-backdrop-filter: blur(10px);  */
  /* backdrop-filter: blur(10px); */

  /* 装饰性样式 */
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3); */
}

.glass-mask-main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
}

.glass-mask-main img {
  margin-right: 10px;
  width: 24px;
  height: 24px;
}
</style>
